import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BfxLadderBlotterContextMenuEvent } from "../../../bfx-base-blotter/bfx-base-blotter-contextmenu.service";

export class BfxBlotterOpsIntContextMenuEvent extends BfxLadderBlotterContextMenuEvent<CubiqTS.OpsIntEventImpl> {}
